import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Link} from 'react-router-dom'
import {Spin, Table, Menu, Dropdown} from 'antd'

import style from './table.sass'

@inject('store') @observer
class ListTable extends Component {
  componentDidMount() {
    this.props.store.backtest.list.load()
  }
  columns = () => [{
    title: 'Algo Name',
    width: '15%',
    render: (text, record) => (
      <Link to={'/backtest/algo/' + record.id} className='btn-link'>{record.algo.name}</Link>
    )
  }, {
    title: 'Strategy',
    dataIndex: 'algo.strategy',
    width: '15%'
  }, {
    title: 'Capital',
    width: '10%',
    render: (text, record) => {
      const capital = record.capital.toLocaleString('en-US', {style: 'currency', currency: 'USD'})
      return capital.substring(0, capital.length - 3)
    }
  }, {
    title: 'Start Date',
    dataIndex: 'start',
    width: '15%',
    render: text => (
      new Date(text).toLocaleString('en-US', {month: 'short', day: 'numeric', year: 'numeric'})
    )
  }, {
    title: 'End Date',
    dataIndex: 'end',
    width: '15%',
    render: text => (
      new Date(text).toLocaleString('en-US', {month: 'short', day: 'numeric', year: 'numeric'})
    )
  }, {
    title: 'Performance',
    width: '10%',
    render: (text, record) => (
      record.performance ?
        record.performance.toLocaleString('en-US', {style: 'percent', minimumFractionDigits: 2})
        :
        '-'
    )
  }, {
    title: 'Sharpe Ratio',
    width: '10%',
    render: (text, record) => (
      record.sharpe_ratio ?
        parseFloat(record.sharpe_ratio).toFixed(2)
        :
        '-'
    )
  }, {
    title: 'Actions',
    width: '10%',
    render: (text, record) => {
      const {permissions, paperTrading} = this.props.store
      const menu = (
        <Menu>
          <Menu.Item>
            <a onClick={() => paperTrading.turnOn({algoId: record.algo.id, redirect: true})}>PaperTrade</a>
          </Menu.Item>
          <Menu.Item>
            <a
              onClick={() => permissions.wrap('account.live_trading.enable', () => this.props.openLiveTradeModal(record.algo))}
              className={permissions.checkUpgrade('account.live_trading.enable') ? `${style.upgrade} upgrade-ribbon` : undefined}
            >
              LiveTrade
            </a>
          </Menu.Item>
          <Menu.Item>
            <Link to={'/builder/edit/' + record.algo.id}>Edit</Link>
          </Menu.Item>
        </Menu>
      )
      return (
        <Dropdown overlay={menu}>
          <a className='ant-dropdown-link'>
            <span className='fas fa-ellipsis-h' />
          </a>
        </Dropdown>
      )
    }
  }]
  changePage = (page) => {
    this.props.store.backtest.list.load(page)
  }
  select = (keys) => {
    this.props.store.backtest.list.select(keys)
  }

  render() {
    const {backtest, paperTrading} = this.props.store
    const {data, loading, pagination, selected} = backtest.list
    return (
      <Spin size='large' spinning={paperTrading.redirecting}>
        <Table
          className='card'
          styleName='table'
          columns={this.columns()}
          dataSource={data}
          rowKey={el => el.algo.id}
          rowSelection={{
            selectedRowKeys: selected,
            onChange: this.select
          }}
          size='small'
          scroll={{y: this.props.height}}
          loading={loading}
          pagination={{
            total: pagination.count,
            pageSize: pagination.size,
            current: pagination.page,
            onChange: this.changePage,
            showTotal: total => `Total ${total} items`
          }}
        />
      </Spin>
    )
  }
}

export default ListTable
